module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(!_vm.passwordChanged) ? [_c('div', {
    staticClass: "col-xs-12 text-xs-center"
  }, [_c('h3', {
    staticClass: "modal__title"
  }, [_vm._v(_vm._s(_vm.$t('SET_NEW_PASSWORD')))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('INSERT_PASSWORD_AND_REPEAT')) + "\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-sm-offset-3 form-group mb-5"
  }, [(_vm.formSubmitted && _vm.errors.any()) ? _c('p', {
    staticClass: "validate-danger"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/images/icons/excl-red.svg")
    }
  }), _vm._v("\n                            " + _vm._s(_vm.$t('COMPLETE_FIELDS_CORRECTLY')) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: _vm.passwordRegex
      }),
      expression: "{ required: true, regex: passwordRegex }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "col-xs-12 mb-3 text-input -white-input-border input",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": _vm.$t('INSERT_NEW_PASSWORD'),
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: _vm.passwordRegex,
        confirmed: _vm.password
      }),
      expression: "{ required: true, regex: passwordRegex, confirmed: password }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordRepeat),
      expression: "passwordRepeat"
    }],
    staticClass: "col-xs-12 col-sm-6 text-input -white-input-border input",
    attrs: {
      "name": "passwordRepeat",
      "placeholder": _vm.$t('PASSWORD_CONFIRM'),
      "type": "password",
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.passwordRepeat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordRepeat = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "app-btn app-btn--small app-btn-primary-reverse --no-border --no-bg",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeWindow.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('CANCEL')) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('SAVE')) + "\n                    ")])])])])] : [_c('div', {
    staticClass: "col-xs-12 text-xs-center"
  }, [_c('h3', {
    staticClass: "modal__title",
    staticStyle: {
      "font-size": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('PASSWORD_CORRECTLY_CHANGED')))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    on: {
      "click": _vm.closeWindow
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d0fe10c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/set-new-password.vue
// module id = 1217
// module chunks = 0